import {EventsFilter} from '../components/interfaces';
import {getEmptyFilters} from "./utils";
const getKeyValue = <U extends keyof T, T extends object>(key: U,obj: T) => obj[key];

export const filterBuilder = (filters: EventsFilter, filterToAdd: string, kind: 'where'|'kind'|'date'): EventsFilter => {
    filters[kind] = filterToAdd;
    return filters;
}

export const getFilterFromPath = (path: string): EventsFilter => {
    const filters = getEmptyFilters()
    const parts = path.split('/');
    parts.forEach(part => {
        if (part.startsWith('city') || part.startsWith('county')) {
            filters.where = part
        }
        if (part.startsWith('category')) {
            filters.kind = part
        }
        if (part.startsWith('date')) {
            filters.date = part
        }
    })
    return filters;
}

export const urlBuilder = (filters: EventsFilter): string => {

    let url = '';
    const kinds = ['where','kind','date']
    for (let filter of kinds) {
        let getPart;
        if (filter === 'where' || filter === 'kind' || filter === 'date') {
            getPart = getKeyValue<keyof EventsFilter, EventsFilter>(filter,filters)
            if (getPart) {
                url = `${url}/${getPart}`
            }
        }
    }
    url = url ? `/events${url}` : '/events'
    return url
}
